module.exports = __webpack_public_path__ + "img/weixin.a7ee8a31.jpg";